<template>
	<div>
		<loading v-if="loadingFlag"></loading>
		<div fillHeight="lastHeight" scroll>
			<stationPythonInfo ref="stationPythonInfo" v-show="crawlShow" :systemNameList="systemNameList"></stationPythonInfo>
			<div v-show="!crawlShow">
				<ul class="pl3x pr3x mb1x">
					<li class="dpT w100pct mt2x pt05x pb05x h5x">
						<div class="dpTC w6x vaT pt1x w6x-max">{{getLanguageStr('plant314','系统名称')}}</div>
						<Select ref="systemNameSelect" :bindActive="bindActive" :list="systemNameList" @Click="select" :size="'m'" class="w100pct"></Select>
					</li>
					<li class="dpT w100pct pt05x pb05x h5x">
						<div class="dpTC w6x w6x-max">{{getLanguageStr('plant312','系统域名')}}</div>
						<input-text class="input" :addClass="{disable:domainReadonly}" v-model="request.siteDomain" :isError="{error:errMsg.siteDomain.show}"></input-text>
						<div class="mt05x" :class="{cError:errMsg.siteDomain.show}" v-show="errMsg.siteDomain.show">{{errMsg.siteDomain.msg}}</div>
					</li>
					<li class="dpT w100pct pt05x pb05x h5x">
						<div class="dpTC w6x w6x-max">{{getLanguageStr('plant313','登录账号')}}</div>
						<input-text class="input" v-model="request.accountName" :isError="{error:errMsg.accountName.show}"></input-text>
						<div class="mt05x" :class="{cError:errMsg.accountName.show}" v-show="errMsg.accountName.show">{{errMsg.accountName.msg}}</div>
					</li>		
					<li class="dpT w100pct pt05x pb05x h5x">
						<div class="dpTC w6x w6x-max">{{getLanguageStr('user60','登录密码')}}</div>
						<input-text class="input" type="password" v-model="request.password" :isError="{error:errMsg.password.show}"></input-text>
						<div class="mt05x" :class="{cError:errMsg.password.show}" v-show="errMsg.password.show">{{errMsg.password.msg}}</div>
					</li>
					<li class="dpT w100pct pt05x pb05x h5x">
						<div class="dpTC w6x w6x-max">{{$t('creat_plant17',['电站名称'])}}</div>
						<input-text class="input" v-model="request.stationName" :isError="{error:errMsg.stationName.show}"></input-text>
						<div class="mt05x" :class="{cError:errMsg.stationName.show}" v-show="errMsg.stationName.show">{{errMsg.stationName.msg}}</div>
					</li>
					<!-- <li class="dpT w100pct pt2x pb05x vaM_E cMain" v-if="tryResult">
						<div class="dpTC w6x" >验证提示：</div>
						<span >{{tryResultText}}</span>
					</li> -->
				</ul>
				<div class="taC">
					<button class="functionBtn bdSub hover-bg-highLight w8x mt2x mr2x" type="button" @click="$emit('goBack')">{{$t('cmd85',['取消'])}}</button>
					<!-- <button class="functionBtn w8x mt2x mb2x" type="button" @click="verify" v-if="tryResultStatus">验证</button> -->
					<button class="functionBtn w8x mt2x mb2x" type="button" @click="verify">{{$t('cmd84',['保存'])}}</button>
				</div>
			</div>
		</div>
	</div>	
</template>
<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
import InputText from "@/components/common/ui/InputText"
import Loading from '@/components/common/ui/Loading'
import Select from "@/components/common/ui/Select.vue"
import stationPythonInfo from './StationPythonInfo'
import {getLanguageStr} from "@/util/language"

import * as lib from "@/util/lib.js"
import * as configApi from '@/api/maintain/config'
let systemNameListAll = [
	{text:getLanguageStr('brand5','华为')+' Fushionsolar',value:"FUSION_SOLAR",customerOut:["customerOutName"]}
]	//先声明，便于随后引用	customerOut:排除用户,customer:包含用户	(stage.loc.customer为空:全显示; list项中无customerOut和customer属性:全显示; customer优先,即list项中customerOut和customer属性都存在的话，只要customer包含就显示，customer不包含则一定不显示)

// let systemNameListAll = [{text:getLanguageStr('brand5','华为')+' Fushionsolar',value:"FUSION_SOLAR",customerOut:["PA"]},{text:getLanguageStr('brand36','固德威')+' SEMS',value:"SEMS",siteDomain:"proxy.solarman.cn:6666/goodwe-spider",lockDomain:true,customer:["pingan"]}]	//示例：用户为pingan的话都显示，用户为PA的话，不显示华为，其他用户都显示(包括stage.loc.customer为空的情况)

export default {
	name: 'stationPython',
	components:{
		InputText,
		Loading,
		Select,
		stationPythonInfo
	},
	data(){
		return{
			loadingFlag:true,
			// systemNameList:stage.loc.customer==""?systemNameListAll:systemNameListAll.filter(item => (!item.customer&&!item.customerOut) || (item.customer&&item.customer.indexOf(stage.loc.customer)>-1) || (item.customerOut&&item.customerOut.indexOf(stage.loc.customer)<0)),	//(stage.loc.customer为空:全显示; list项中无customerOut和customer属性:全显示; customer优先,即list项中customerOut和customer属性都存在的话，只要customer包含就显示)
			systemNameList:this.mathSystemNameList(),
			bindActive:'',//systemNameList[0].value,	//
			currentIndex:0,
			domainReadonly:'',//systemNameList[0].lockDomain||false,
			request:{
				type:'',//systemNameList[0].value, //系统名称
				siteDomain:'',//systemNameList[0].siteDomain||'', //系统域名
				accountName:'',//登录账号
				password:'',//登录密码
				stationName:'' //电站名称
			},
			errMsg: {
				siteDomain: { msg: '', show: false},
				accountName: { msg:'', show: false, },
				password: { msg: '', show: false },
				stationName: { msg: '', show: false }
			},
			tryResult:null,
			tryResultText:'',
			stationInfo:null,
			// isShow:false
		}
	},
	computed:{
		...mapGetters({
			stationId: 'stationDetail/stationId',
			crawlConfig:'stationConfig/crawlConfig',
			crawlShow:'stationConfig/crawlShow'
		}),
		siteDomain(){
			return this.request.siteDomain
		},
		accountName(){
			return this.request.accountName
		},
		password(){
			return this.request.password
		},
		stationName(){
			return this.request.stationName
		}

	},
	watch:{
		siteDomain(newValue,oldValue){
			if(newValue){
				this.errMsg.siteDomain.show=false
			}
		},
		accountName(newValue,oldValue){
			if(newValue){
				// if(this.errMsg.accountName.msg==getLanguageStr('phrase28','用户名或密码错误')||this.errMsg.accountName.msg=='登录请求异常'||this.errMsg.accountName.msg=='登录请求失败'){
				// 	this.errMsg.password.show=false
				// }
				if(this.errMsg.accountName.msg==getLanguageStr('user48','账号或密码错误')||this.errMsg.accountName.msg==getLanguageStr('plant331','域名访问超时')){
					this.errMsg.password.show=false
				}
				this.errMsg.accountName.show=false
			}
		},
		password(newValue,oldValue){
			if(newValue){
				// if(this.errMsg.password.msg==getLanguageStr('phrase28','用户名或密码错误')||this.errMsg.password.msg=='登录请求异常'||this.errMsg.password.msg=='登录请求失败'){
				// 	this.errMsg.accountName.show=false
				// }
				if(this.errMsg.password.msg==getLanguageStr('user48','账号或密码错误')||this.errMsg.password.msg==getLanguageStr('plant331','域名访问超时')){
					this.errMsg.accountName.show=false
				}
				this.errMsg.password.show=false
			}
		},
		stationName(newValue,oldValue){
			if(newValue){
				this.errMsg.stationName.show=false
			}
		}
	},
	methods:{
		...mapMutations({
			GET_CRAWLSHOW:'stationConfig/GET_CRAWLSHOW'
		}),
		...mapActions({
			GETCRAWLCONFIG:'stationConfig/GETCRAWLCONFIG'
		}),
		getLanguageStr,
		mathSystemNameList(){
			let newList=systemNameListAll.concat();
			if(stage.loc.loginSystem.hasOwnProperty('um') && stage.loc.loginSystem.um==true){//um系统
				newList.splice(newList.length,0,
					{text:getLanguageStr('brand36','固德威')+' SEMS',value:"SEMS",siteDomain:"proxy.solarman.cn:6666/goodwe-spider",lockDomain:true},
					{text:"优德",value:"UPER_ENERGY",siteDomain:(stage.loc.loginSystem.out.prod.host.indexOf(locatiokn.host)>=0?"proxy.solarman.cn/uper-energy":"proxy.solarman.cn:6666/demo-uper-energy")},
					{text:"晶科",value:"JIN_KO",siteDomain:"proxy.solarman.cn:6666/jk",lockDomain:true}
				);
			}else{
				newList.splice(newList.length,0,
					{text:getLanguageStr('brand36','固德威')+' SEMS',value:"SEMS",siteDomain:"proxy.solarman.cn/goodwe-spider",lockDomain:true},
					{text:"优德",value:"UPER_ENERGY",siteDomain:"unicare.uper-energy.com"},
					{text:"晶科",value:"JIN_KO",siteDomain:"jk.jinkopower.com",lockDomain:true}
				);
				// systemNameListAll.forEach(item=>{
				// 	 if(item.hasOwnProperty('siteDomain')){
				// 		 item.siteDomain='proxy.solarman.cn/goodwe-spider'
				// 	 }
				// })
			}
			return newList;
		},
		init(){
			this.bindActive = this.systemNameList[0].value
			this.domainReadonly = this.systemNameList[0].lockDomain||false
			this.request.type = this.systemNameList[0].value
			this.request.siteDomain = this.systemNameList[0].siteDomain||''
		},
		select(index){
			// this.$set(this.request,'systemName',this.systemNameList[index].value)
			this.currentIndex=index
			this.$set(this.request,"type",this.systemNameList[index].value)
			this.$set(this.request,"siteDomain",this.systemNameList[index].siteDomain||"")	//有域名则替换，无则清空
			this.$set(this.request,"accountName","")
			this.$set(this.request,"password","")
			this.$set(this.request,"stationName","")
			this.$set(this,"domainReadonly",this.systemNameList[index].lockDomain||false)
			this.$set(this,"bindActive",this.systemNameList[index].value)
		},
		//验证错误提示
		matchResult(val){
			switch (val){
				case 'USER_NAME_OR_PASSWORD_INVALID':
					this.errMsg.accountName.msg=getLanguageStr('user48','账号或密码错误')
					this.errMsg.accountName.show=true
					this.errMsg.password.msg=getLanguageStr('user48','账号或密码错误')
					this.errMsg.password.show=true
					break;
				case 'CONNECT_FAILED':
					this.errMsg.siteDomain.msg=getLanguageStr('plant331','域名访问超时')//连接不上，可能是端口错误，也可能是对方服务挂了
					this.errMsg.siteDomain.show=true
					break;
				case 'DOMAIN_INVALID':
					this.errMsg.siteDomain.msg=getLanguageStr('plant331','域名访问超时')//域名无法解析
					this.errMsg.siteDomain.show=true
					break;
				case 'LOGIN_REQUEST_EXCEPTION':
					this.errMsg.accountName.msg=getLanguageStr('plant331','域名访问超时')//登陆请求正确，但发生了异常
					this.errMsg.accountName.show=true
					this.errMsg.password.msg=getLanguageStr('plant331','域名访问超时')//登陆请求正确，但发生了异常
					this.errMsg.password.show=true
					break;
				case 'LOGIN_REQUEST_FAILED':
					this.errMsg.accountName.msg=getLanguageStr('plant331','域名访问超时')//登录请求失败
					this.errMsg.accountName.show=true
					this.errMsg.password.msg=getLanguageStr('plant331','域名访问超时')//登录请求失败
					this.errMsg.password.show=true
					break;
				case 'STATION_REQUEST_EXCEPTION':
					this.errMsg.stationName.msg=getLanguageStr('plant331','域名访问超时')//电站请求正确，但发生了异常
					this.errMsg.stationName.show=true
					break;
				case 'STATION_REQUEST_FAILED':
					this.errMsg.stationName.msg=getLanguageStr('plant331','域名访问超时')//电站请求正确，但服务器没能正确返回
					this.errMsg.stationName.show=true
					break;
				case 'STATION_NAME_NOT_FOUND':
					this.errMsg.stationName.msg=getLanguageStr("phrase617","无此电站，请确保名称一致。如名称一致仍找不到请联系系统提供商")
					this.errMsg.stationName.show=true
					break;
			}
		},
		reset(){
			this.request={
				type:this.systemNameList[0].value, //系统名称
				siteDomain:this.systemNameList[0].siteDomain||'', //系统域名
				accountName:'',//登录账号
				password:'',//登录密码
				stationName:'' //电站名称
			}
			this.currentIndex = 0
			this.bindActive=this.systemNameList[0].value
			this.domainReadonly = this.systemNameList[0].lockDomain||false
			this.stationInfo=null
			this.loadingFlag=true
			this.GET_CRAWLSHOW(false)
			this.$refs.systemNameSelect.myIndex=0;
			this.bindActive=""
			this.resetErrMsg()
		},
		resetErrMsg(){
			for(let attr in this.errMsg){
				this.errMsg[attr].show=false
			}
		},
		// 验证
		verify(){
			let notSupportAgreement = "HTTPS"
			if(this.request.siteDomain==""){
				this.errMsg.siteDomain.show=true
				this.errMsg.siteDomain.msg=getLanguageStr('phrase3','不能为空')
			}
			if(this.request.siteDomain.substr(0,8).toUpperCase()==notSupportAgreement+"://"){
				this.errMsg.siteDomain.show=true
				this.errMsg.siteDomain.msg='不支持'+notSupportAgreement
			}
			if(this.request.accountName==""){
				this.errMsg.accountName.show=true
				this.errMsg.accountName.msg=getLanguageStr('phrase3','不能为空')
			}
			if(this.request.password==""){
				this.errMsg.password.show=true
				this.errMsg.password.msg=getLanguageStr('phrase3','不能为空')
			}
			if(this.request.stationName==""){
				this.errMsg.stationName.show=true
				this.errMsg.stationName.msg=getLanguageStr('phrase3','不能为空')
			}
			if(this.request.siteDomain !="" && this.request.accountName !="" && this.request.password !="" && this.request.stationName !=""){
				// console.log("currentIndex="+this.currentIndex)
				if (this.systemNameList[this.currentIndex].lockDomain) {	//对锁定域名的设置锁死初始域名
					this.$set(this.request,"siteDomain",this.systemNameList[this.currentIndex].siteDomain)
				}
				configApi.postCrawlTry(this.stationId,this.request).then(res=>{
					this.tryResult=res
					if(res.crawlStatus=='NORMAL'){
						// console.log(this.request)
						this.save()
					}else{
						this.matchResult(res.crawlStatus)
					}
				},error=>{
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		//获取
		getCrawlConfig(){
			this.GETCRAWLCONFIG(this.stationId).then(res=>{
				if(res){
					this.GET_CRAWLSHOW(true)
					let {stationName,siteDomain,password,accountName,type}=res.source
					// type ="SEMS"	//测试
					this.$set(this,"bindActive",type)
					this.$set(this,"currentIndex",lib.getObjArray(this.systemNameList,type,"value"))
					this.$set(this,"domainReadonly",this.systemNameList[this.currentIndex].lockDomain||false)
					this.request={
						type:type, 
						siteDomain:siteDomain, 
						accountName:accountName,
						password:password,
						stationName:stationName
					}
					// console.log(this.request)
					this.$refs.stationPythonInfo.getCrawlStats(this.stationId)
				}
				this.$nextTick(()=>{
					this.loadingFlag=false
				})
			}).catch(error=>{
				this.loadingFlag=false
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		//保存更新
		save(){
			configApi.postCrawlConfig(this.stationId,this.request).then(res=>{
				// console.log(res)
				this.GETCRAWLCONFIG(this.stationId).then(res=>{
					// console.log(res)
				})
				this.GET_CRAWLSHOW(true)
				this.$refs.stationPythonInfo.getCrawlStats(this.stationId)
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
	},
	mounted(){
		this.init()
	},
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationPython.vue